import React from 'react'
import { useIntl } from 'react-intl'

export const MailTo = () => {
    const intl = useIntl()
    return <>{ intl.locale === 'cs-CZ' 
        ? <a href='mailto: michaela@vegilove.cz' title='Michaela Levíčková'>michaela@vegilove.cz</a>
        : <a href='mailto: michaela@vegilove.eu' title='Michaela Levíčková'>michaela@vegilove.eu</a>
    }</>
}